module.exports = __webpack_public_path__ + "img/car1_7.006c9fd2.png";